import React from "react";
import styles from './slogon.module.scss'
import slogonImg from 'images/GPremium-brand.svg'
export const Slogon = ()=>{
    return <div className={styles.container}>
                <img className={styles.slognImg} src={slogonImg}/>
           </div>
};
